<ng-template #template>
  <div class="context-menu" cdkMenu>
    <button
      *ngIf="index !== 0"
      cdkMenuItem
      mat-menu-item
      class="context-menu-item"
      type="button"
      (click)="emitMove('up')"
    >
      Move Up
    </button>
    <button
      *ngIf="index !== total - 1"
      cdkMenuItem
      mat-menu-item
      class="context-menu-item"
      type="button"
      (click)="emitMove('down')"
    >
      Move Down
    </button>
    <button
      *ngIf="index !== 0"
      cdkMenuItem
      mat-menu-item
      class="context-menu-item"
      type="button"
      (click)="emitMove('start')"
    >
      Move to Top
    </button>
    <button
      *ngIf="index !== total - 1"
      cdkMenuItem
      mat-menu-item
      class="context-menu-item"
      type="button"
      (click)="emitMove('end')"
    >
      Move to Bottom
    </button>
    <ng-container *ngIf="showRemove">
      <mat-divider></mat-divider>
      <button
        cdkMenuItem
        mat-menu-item
        class="context-menu-item"
        type="button"
        (click)="emitRemove()"
      >
        {{ removeLabel }}
      </button>
    </ng-container>
  </div>
</ng-template>
